import axios from 'axios';
import Cookies from 'js-cookie';
import { message } from 'antd';
//
import actions from './actions';
import serverAxios from '../../axios';
import errorHandling from '../../error';
import { getHeaders } from '../../../utils/common';

const carAmigoInstance = axios.create({
  baseURL: process.env.REACT_APP_CAR_AMIGO_API,
});
const CarAmigoJWTKey = 'caramigo-jwt';

const {
  getCarAmigoBegin,
  getCarAmigoFailed,
  getCarAmigoSuccess,
  postCarImportBegin,
  postCarImportFailed,
  postCarImportSuccess,
  getCarAmigoDetailBegin,
  getCarAmigoDetailSuccess,
  getCarAmigoDetailFailed,
  requestCarAmigoBegin,
  requestCarAmigoFailed,
  requestCarAmigoSuccess,
  postLoginBegin,
  postLoginFailed,
  postLoginSuccess,
  getAlreadyImportedCarsBegin,
  getAlreadyImportedCarsFailed,
  getAlreadyImportedCarsSuccess,
  deleteImportedCarBegin,
  deleteImportedCarFailed,
  deleteImportedCarSuccess,
  getImportedCarIdsBegin,
  getImportedCarIdsFailed,
  getImportedCarIdsSuccess,
  getRequestedCarsBegin,
  getRequestedCarsFailed,
  getRequestedCarsSuccess,
  reRequestCarBegin,
  reRequestCarFailed,
  reRequestCarSuccess,
  putCarInspectionBegin,
  putCarInspectionFailed,
  putCarInspectionSuccess,
  putPaymentOrderBegin,
  putPaymentOrderFailed,
  putPaymentOrderSuccess,
  putPurchaseOrderBegin,
  putPurchaseOrderFailed,
  putPurchaseOrderSuccess,
  logoutUser,
  reOrderImportedCarBegin,
  reOrderImportedFailed,
  reOrderImportedSuccess,
  setImportedCars,
  setAllImportedCarIds,
  reFetchImportedCarBegin,
  reFetchImportedCarSuccess,
  reFetchImportedCarFailed
} = actions;

// TODO check if the 401 status code is correctly accessed
// TODO get the correct value from error message of response
// TODO fix the page refresh when calling dispatch errorHandling
export const carAmigoLogin = (email, password) => async dispatch => {
  try {
    dispatch(postLoginBegin());
    const res = await carAmigoInstance.post(`/api/auth/partner-agent/login`, {
      email,
      password,
    });

    Cookies.set(CarAmigoJWTKey, res.data.jwt);
    dispatch(postLoginSuccess());
    message.success(`Login Successful`);
    return res;
  } catch (err) {
    dispatch(postLoginFailed(err));
    if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
      message.error('Login Failed: Invalid email or password');
    }
    // dispatch(errorHandling(err, false));
    return err;
  }
};

export const logoutCarAmigoUser = async dispatch => {
  Cookies.remove(CarAmigoJWTKey);
  dispatch(logoutUser());
};

export const getCarAmigoCars = (filter, page, pageLimit) => async dispatch => {
  try {
    const jwt = Cookies.get(CarAmigoJWTKey);
    dispatch(getCarAmigoBegin());
    const res = await carAmigoInstance.get(`/api/export/partner/vehicles/${filter}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });
    if (res.data) {
      dispatch(getCarAmigoSuccess({ data: res.data.data || [], page, pageLimit, total: res.data.total }));
    }
    return res;
  } catch (err) {
    if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
      dispatch(postLoginFailed());
    } else {
      message.error('Failed to get caramigo car listing');
    }
    dispatch(getCarAmigoFailed(err));
    // dispatch(errorHandling(err?.response?.data?.message?.error));
    return err;
  }
};

export const getCarAmigoDetail = id => async dispatch => {
  try {
    dispatch(getCarAmigoDetailBegin());
    const jwt = Cookies.get(CarAmigoJWTKey);
    const res = await carAmigoInstance.get(`/api/export/partner/vehicle/${id}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });
    dispatch(getCarAmigoDetailSuccess(res.data));
    return res;
  } catch (err) {
    if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
      dispatch(postLoginFailed());
    }
    // dispatch(getCarAmigoDetailFailed(err));
    dispatch(errorHandling(err));
    return err;
  }
};

export const getAlreadyImportedCars = filter => async dispatch => {
  try {
    dispatch(getAlreadyImportedCarsBegin());
    const res = await serverAxios.get(`cars?${filter || ''}`, {
      headers: { ...getHeaders() },
    });
    dispatch(getAlreadyImportedCarsSuccess(res.data));
    return res;
  } catch (err) {
    dispatch(getAlreadyImportedCarsFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err));
    return err;
  }
};

export const deleteImportedCar = (incomingId) => async dispatch => {
  try {
    dispatch(deleteImportedCarBegin());
    const res = await serverAxios.delete(`external/car-amigo/delete/${incomingId}`, { headers: { ...getHeaders() } });
    if (res.status === 200) {
      message.success('Imported Car Deleted');
    }
    dispatch(deleteImportedCarSuccess());
    return res;
  } catch (err) {
    dispatch(deleteImportedCarFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err));
    return err;
  }
};

export const reFetchImportedCar = (incomingId) => async dispatch => {
  try {
    dispatch(reFetchImportedCarBegin());
    const jwt = Cookies.get(CarAmigoJWTKey);
    const res = await serverAxios.post(
      `external/car-amigo/re-fetch/${incomingId}`, 
      { token: jwt }, 
      { headers: { ...getHeaders() } }
    );
    if (res.status === 200) {
      message.success('Imported Car Re-Fetched');
    }
    dispatch(reFetchImportedCarSuccess());
    return res;
  } catch (err) {
    dispatch(reFetchImportedCarFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err));
    return err;
  }
};

export const requestCarAmigo = data => async dispatch => {
  try {
    dispatch(requestCarAmigoBegin());
    const jwt = Cookies.get(CarAmigoJWTKey);
    const res = await serverAxios.post('external/car-amigo/request', { data, token: jwt });
    if (!res.data.status) throw new Error('Failed to request car');
    message.success('Car Requested');
    dispatch(requestCarAmigoSuccess());
    return res;
  } catch (err) {
    dispatch(requestCarAmigoFailed(err?.response?.data?.message));
    dispatch(errorHandling(err));
    return err;
  }
};

export const reRequestCar = id => async dispatch => {
  try {
    dispatch(reRequestCarBegin(id));
    const jwt = Cookies.get(CarAmigoJWTKey);
    const res = await serverAxios.post('external/car-amigo/re-request', {
      id,
      token: jwt,
    });
    dispatch(reRequestCarSuccess());
    message.success('Re Requested for Car');
    return res;
  } catch (err) {
    dispatch(reRequestCarFailed(err?.response?.data?.message));
    dispatch(errorHandling(err));
    return err;
  }
};

export const getRequestedCars = filter => async dispatch => {
  try {
    dispatch(getRequestedCarsBegin());
    const res = await serverAxios(`external/car-amigo/request?${filter || ''}`, {
      headers: { ...getHeaders() },
    });
    dispatch(getRequestedCarsSuccess(res.data));
    return res;
  } catch (err) {
    dispatch(getRequestedCarsFailed());
    return err;
  }
};

export const getImportedCarIds = portal => async dispatch => {
  try {
    dispatch(getImportedCarIdsBegin());
    let url = `external/car-amigo/imported?type=all`;
    if (portal) {
      url += `&portal=${portal}`;
    }
    const res = await serverAxios.get(url, {
      headers: { ...getHeaders() },
    });
    dispatch(getImportedCarIdsSuccess(res.data.data));
    return res;
  } catch (err) {
    dispatch(getImportedCarIdsFailed(err));
    dispatch(errorHandling(err));
    return err;
  }
};

export const postImportCars = (ids, portal) => async dispatch => {
  try {
    dispatch(postCarImportBegin());
    const token = Cookies.get(CarAmigoJWTKey);
    const res = await serverAxios.post(
      `external/car-amigo/import`,
      { ids, token, portal },
      {
        headers: { ...getHeaders() },
      },
    );
    message.success('Cars Imported');
    dispatch(postCarImportSuccess());
    return res;
  } catch (err) {
    dispatch(postCarImportFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err, false));
    return err;
  }
};

export const requestCarInspection = id => async dispatch => {
  try {
    dispatch(putCarInspectionBegin(id));
    const jwt = Cookies.get(CarAmigoJWTKey);
    const res = await carAmigoInstance.put(`/api/export/partner/vehicule/${id}/start-car-checking`, null, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });
    dispatch(putCarInspectionSuccess());
    message.success('Car Inspection Started');
    return res;
  } catch (err) {
    if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
      dispatch(postLoginFailed());
    }
    dispatch(putCarInspectionFailed());
    dispatch(errorHandling(err));
    return err;
  }
};

export const startPurchaseOrder = (id, offeredPrice) => async dispatch => {
  try {
    dispatch(putPurchaseOrderBegin(id));
    const jwt = Cookies.get(CarAmigoJWTKey);
    const res = await carAmigoInstance.put(
      `/api/export/partner/vehicule/${id}/start-purchase-order`,
      { offeredPrice },
      {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      },
    );
    dispatch(putPurchaseOrderSuccess());
    message.success('Purchase Order Started');
    return res;
  } catch (err) {
    if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
      dispatch(postLoginFailed());
    }
    dispatch(putPurchaseOrderFailed());
    dispatch(errorHandling(err));
    return err;
  }
};

export const startPayment = id => async dispatch => {
  try {
    dispatch(putPaymentOrderBegin());
    const jwt = Cookies.get(CarAmigoJWTKey);
    const res = await carAmigoInstance.put(`/api/export/partner/vehicule/${id}/start-payment`, null, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });
    dispatch(putPaymentOrderSuccess());
    message.success('Payment Started');
    return res;
  } catch (err) {
    if (err.status === 401) {
      dispatch(postLoginFailed());
    }
    dispatch(putPaymentOrderFailed());
    dispatch(errorHandling(err));
    return err;
  }
};

export const reOrderImportedCar = (incomingId, newOrderIndex) => async dispatch => {
  try {
    dispatch(reOrderImportedCarBegin());
    const res = await serverAxios.post(
      `external/car-amigo/re-order`,
      { incomingId, newOrderIndex },
      {
        headers: { ...getHeaders() },
      },
    );
    dispatch(reOrderImportedSuccess());
    return res;
  } catch (err) {
    dispatch(reOrderImportedFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err));
    return err;
  }
};

export const setImportCarsData = data => dispatch => {
  dispatch(setImportedCars(data));
};

export const setAllImportedCarIdsData = data => dispatch => {
  dispatch(setAllImportedCarIds(data));
};
